export default "__VITE_ASSET__BCA0hlfI__"